module.exports = "<jhi-button cancellation\n    icon=\"fa-arrow-circle-left\"\n    [isLoading]=\"isLoading\"\n    [isDisabled]=\"isLoading || isDisabled\"\n    (onClick)=\"onClickButton($event)\">\n    {{ label ? label : 'Précédent' }}\n    <ng-content></ng-content>\n</jhi-button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/forms/button/previous-button/previous-button.component.html
// module id = 843
// module chunks = 0